import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { asyncForEach, isToday } from '@/utils';
import * as XLSX from 'xlsx';
import moment from 'moment-timezone';

export interface Pdv {
    // Define tu interfaz aquí
    info_sale: products_sale[];
    box_id: number;
    data_sale: any;
    session_pdv: any;
    close_flag?: boolean; // Indica si se ha cerrado la caja
    session_id: any;
    totalv_history: number;
    monthlySummary: boolean;
}

export interface products_sale {
    id_product: number;
    sku: string;
    description: string;
    price: number;
    quantity: number;
    amount: number; // precio * cantidad inicial (1)
    barcode: string
}

const state: Pdv = {
    info_sale: [],
    box_id: 1,
    data_sale: {},
    session_pdv: {},
    close_flag: null,
    session_id: 0,
    totalv_history: 0,
    monthlySummary: false
};

export interface IDataSale {
    box?: number
    payment_way?: string
    subtotal?: number
    discount?: number
    iva?: number
    total?: number
    date?: any,
    user?: string
    code?: string
    payment_condition?: string
}

export interface IDataCloseBox {
    box?: number
    user?: string
    initial_cash?: number
    final_cash?: number
    amount_credit?: number
    amount_debit?: number
    amount_cash?: number
    cashdetails?: any
    total?: number
    date_open?: any
    date_close?: any
    fixed_amount?: any
}

export interface ISalesPdv {
    amount_card_credit: Number
    amount_card_debit: Number
    amount_cash: Number
    change_money: Number
    date_created: string
    id: Number
    is_active: boolean
    iva_total: Number
    last_updated: string
    session_id: string
    subtotal: Number
    total: Number
    total_discount: Number
    user_id: string
}

const mutations = {
    ADD_PRODUCT_TO_SALE(state: Pdv, product: any): void {
        const existingItem = state.info_sale.find(item => item.sku === product.id); //Buscar si existe el codigo de barras en el array
        if (!existingItem) {
            const new_sale_product: products_sale = {
                id_product: product.id_new,
                sku: product.id,
                description: product.name,
                price: product.price,
                quantity: 1,
                amount: product.price,
                barcode: product.ean_upc,
            };
            state.info_sale.push(new_sale_product);
        } else {
            existingItem.quantity += 1;
            existingItem.amount = existingItem.quantity * existingItem.price;
        }
    },

    END_SALE(state: Pdv) {
        state.info_sale = [];
    },

    setInfoSale(state: Pdv, data: products_sale[]) {
        state.info_sale = data;
    },

    SET_DATA_SALE(state: Pdv, data: any) {
        state.data_sale = data;
    },

    SET_SESSION_PDV(state: Pdv, data: any) {
        state.session_pdv = data;
    },
    SET_CLOSE_FLAG(state: Pdv, data: any) {
        state.close_flag = data;
    },
    SET_TOTAL_HISTORY(state: Pdv, total: number) {
        state.totalv_history = total
    },
    monthlySummaryLoading(state: Pdv, data: boolean) {
        state.monthlySummary = data;
    }
};

// Actions
const actions = {
    async getBoxStatus({ state, commit, dispatch }: any, user: any) {
        const box = await directusApi('GET', `items/sessions_pdv_v1?filter[user_id][_eq]=${user}&filter[date_close][_eq]=${null}`);
        commit('SET_SESSION_PDV', box.data.data[0]);
        if (box.data.data.length == 0) return false;
        else return true;
    },

    async verificarCodigo({ commit }, code: any) {
        const response = await directusApi('GET', 'users?filter[confirm_code_pdv][_neq]=null');
        const existe = response.data.data.some(user => user.confirm_code_pdv === code);
        console.log("El código existe: ", existe);

        return existe
    },

    async getProductInfo({ state, commit, dispatch }: any, data: any) {
        try {
            if (data.scan.trim() == '' || data.scan == 0) {
                return;
            }
            let code = data.scan.trim();
            code = data.scan.toUpperCase();
            const product_sku = await directusApi('GET', `items/products?filter[id][_eq]=${code}`);
            if (product_sku.data.data.length == 0) {
                const product_scan = await directusApi('GET', `items/products?filter[ean_upc][_eq]=${code}`);
                if (product_scan.data.data.length == 0) {
                    console.log('no existe producto');
                    data.vm.$bvToast.toast('No se encontró el producto solicitado', {
                        title: `Producto ${code} no encontrado`,
                        variant: 'warning',
                        toaster: 'b-toaster-top-center',
                        noAutoHide: true
                        // autoHideDelay: 5000,
                    });
                } else {
                    if (+product_scan.data.data[0].price > 0) {
                        commit('ADD_PRODUCT_TO_SALE', product_scan.data.data[0]);
                        data.vm.$bvToast.toast('Se agrego el producto correctamente', {
                            title: `Producto ${code} agregado`,
                            variant: 'success',
                            toaster: 'b-toaster-top-center',
                            // noAutoHide: true
                            autoHideDelay: 3000,
                        });
                    } else {
                        data.vm.$bvToast.toast('Lo sentimos, no se ha podido agregar el producto debido a que no cuenta con la información suficiente', {
                            title: `Producto ${code} no disponible`,
                            variant: 'warning',
                            toaster: 'b-toaster-top-center',
                            noAutoHide: true
                        });
                    }
                }
            } else {
                if (+product_sku.data.data[0].price > 0) {
                    commit('ADD_PRODUCT_TO_SALE', product_sku.data.data[0]);
                    // console.log(state.info_sale);
                    data.vm.$bvToast.toast('Se agrego el producto correctamente', {
                        title: `Producto ${code} agregado`,
                        variant: 'success',
                        toaster: 'b-toaster-top-center',
                        // noAutoHide: true
                        autoHideDelay: 3000,
                    });
                } else {
                    data.vm.$bvToast.toast('Lo sentimos, no se ha podido agregar el producto debido a que no cuenta con la información suficiente', {
                        title: `Producto ${code} no disponible`,
                        variant: 'warning',
                        toaster: 'b-toaster-top-center',
                        noAutoHide: true
                    });
                }
            }
            return data.products_sale; // Retornar el array actual
        } catch (error) {
            console.error('Error en getProductInfo:', error);
            return data.products_sale; // Retornar el array actual en caso de error
        }
    },

    async openBox({ _, commit }: any, body: any) {
        const sessions = await directusApi('POST', 'items/sessions_pdv_v1', body);
        commit('SET_SESSION_PDV', sessions.data.data);
        return sessions.data.data;
    },

    async saveSale({ _, commit, state }: any, payload: any) {
        const { sale, detail_sale } = payload;
        let band_sale = false
        let band_intelisis = false
        try {
            const sale_payload = { 'sale': sale, 'sale_detail': detail_sale }
            // Crear venta
            const session = await directusApi('GET', `items/sessions_pdv_v1?filter[user_id][_eq]=${sale.user_id}&filter[date_close][_eq]=${null}`);
            sale.session_id = session.data.data[0].id;
            const saleRes = await directusApi(
                'POST',
                'custom/api/post_one_sale',
                sale_payload
            )
            sale.detail = detail_sale;
            band_sale = true
            const repeat_sale = saleRes.data.repeat_sale
            const sale_id = saleRes.data.detail_sale.new_sale[0].id
            sale.id = sale_id

            commit('SET_DATA_SALE', saleRes.data.detail_sale.new_sale[0]);
            console.log(saleRes);
            if (!repeat_sale) {
                try {
                    // await directusApi(
                    //     'POST',
                    //     'custom/legacy-intelisis/intelisisQuotationPdv',
                    //     sale
                    // );
                    // console.log(sale);
                    // console.log('Cotización insertada en intelisis');
                    // await directusApi('PATCH', `items/sales_pdv_v1/${sale_id}`, { intelisis_status: true });
                    await directusApi('PATCH', `items/sales_pdv_v1/${sale_id}`, { intelisis_status: false });
                } catch (error) {
                    if (error.response) {
                        console.error('Error con respuesta:', error.response.status, error.response.data);
                    } else {
                        console.error('Error sin respuesta:', error.message);
                    }
                    band_sale = true;
                    payload.vm.$bvToast.toast(`Venta generada en Prodelec Digital`, {
                        title: `Venta realizada`,
                        variant: 'info',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                    return saleRes.data.detail_sale;// Asegurar el flujo 
                }
            }

            // let intelisis_ressponse = await directusApi('POST', 'custom/legacy-intelisis/intelisisQuotationPdv', sale);
            // console.log({ intelisis_response });
            band_sale = true
            return saleRes.data;

        } catch (error) {
            console.error('Error en saveSale store:', error);

            if (!band_sale) {
                payload.vm.$bvToast.toast(`Ocurrió un error al realizar compra`, {
                    title: `Error`,
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                throw error;
            }

            if (!band_intelisis) {
                payload.vm.$bvToast.toast(`Ocurrió un error al conectar con sistema`, {
                    title: `Error`,
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                throw error;
            }
        }
    },

    async getCloseInfo({ _, commit }: any, data: any) {
        console.log(data);
        const salesInfo = await directusApi('GET', `items/sales_pdv_v1?filter[session_id][_eq]=${data.data.id}&limit=-1`);
        let sales = salesInfo.data.data;
        const activeSales = sales.filter(sale => sale.is_active === true);
        let totalAmount: any = 0;
        let totalCash: any = 0;
        let totalCards: any = 0;
        if (sales.length > 0) {
            //Validando si hay ventas para realizar el corte
            // 1. Filtrar registros activos
            const activeSales = sales.filter(sale => sale.is_active === true);
            // 2. Sumar los campos deseados
            totalCash = activeSales.reduce((sum, sale) => sum + (+sale.amount_cash - +sale.change_money), 0);
            const totalCredit = activeSales.reduce((sum, sale) => sum + +sale.amount_card_credit, 0);
            const totalDebit = activeSales.reduce((sum, sale) => sum + +sale.amount_card_debit, 0);
            totalCards = totalCredit + totalDebit;
            totalAmount = totalCash + totalCredit + totalDebit;
            // console.log({ totalCards });
            // console.log({ totalCash });
            // console.log({ totalAmount });
        }
        if (!totalAmount) totalAmount = '0.00';
        const num = Number(totalAmount);
        let formatAmount = '0.00';
        if (isNaN(num)) {
            totalAmount = '0.00';
        } else {
            formatAmount = num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
        let session_pdv = {
            ...data.data,
            close_box_amount: +Number(totalAmount).toFixed(2),
            close_box_amount_formatted: formatAmount,
            close_box_cash: +Number(totalCash).toFixed(2),
            close_box_card: +Number(totalCards).toFixed(2),
        };
        commit('SET_SESSION_PDV', session_pdv);
    },

    async closeBox({ _, commit }: any, data: any) {
        commit('SET_CLOSE_FLAG', false);
        return await directusApi('PATCH', `items/sessions_pdv_v1/${data.data.id}`, {
            amount_close: data.box_cut_amount,
            amount_box_cut: data.box_cut_amount,
            amount_cash: 0,
            // amount_cash: data.totalCash,
            amount_card_credit: data.totalCredit,
            amount_card_debit: data.totalDebit,
            date_close: moment().tz('America/Mexico_City').toISOString(),
            amount_detail: data.amountDetail ? data.amountDetail : null,
        })
            .then(res => {
                commit('SET_CLOSE_FLAG', true);
                data.vm.$bvToast.toast('Caja cerrada correctamente', {
                    title: 'Éxito',
                    variant: 'success',
                    solid: true,
                });
                return res;
            })
            .catch(err => {
                console.log(err);
                commit('SET_CLOSE_FLAG', null);
                data.vm.$bvToast.toast('Ha ocurrido un error, trata de nuevo más tarde', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                });
            });
    },

    async updateUser({ _, commit }: any, payload: any) {
        const user = await directusApi('PATCH', `users/${payload.id}`, {
            confirm_code_pdv: payload.confirm_code_pdv,
        });
        console.log('user', user);
    },

    async getSessions({ _, commit }: any,
        payload: {
            page: 1,
            start_date: null,
            end_date: null,
            search: null
        }
    ) {

        const { page, start_date, end_date, search } = payload
        let filter = false

        let url = `custom/api/get_name_user?limit=10&page=${page}&sort=-date_close&meta=total_count&meta=filter_count`
        // let url = `items/sessions_pdv_v1?limit=10&page=${page}&sort=-date_close&meta=total_count&meta=filter_count`

        if (start_date && end_date) {
            filter = true
            url += `&filter[date_open][_between]=${start_date},${end_date}`
        }

        const sessions = await directusApi('GET', url);
        // const sells = sessions.data.data
        // const total_sells = filter ? sessions.data.meta.filter_count : sessions.data.meta.total_count


        const sells = sessions.data.data
        const total_sells = sessions.data.pagination.total

        commit('SET_TOTAL_HISTORY', total_sells)
        return sells;
    },

    async getSalesBySession({ commit }: any, payload: { id: number }) {
        try {
            const response = await directusApi('GET', `items/sales_pdv_v1?filter[session_id][_eq]=${payload.id}&sort=id&limit=-1`);
            console.log({ response });

            return response.data.data;
        } catch (error) {
            console.error('Error al obtener ventas por sesión:', error);
            throw error;
        }
    },
    async getDocInvoices() {
        try {
            // Fecha de inicio: primer día del mes a las 10:00:00
            const startDate = moment().startOf('month')
                .hour(10).minute(0).second(0).millisecond(0)
                .format('YYYY-MM-DD HH:mm:ss.SS');

            // Fecha de fin: ÚLTIMO MOMENTO DEL DÍA DE HOY (23:59:59.999)
            const endDate = moment()
                .format('YYYY-MM-DD HH:mm:ss.SS');

            const url = `items/sales_pdv_v1?filter[date_created][_between]=${startDate},${endDate}&filter[invoice_status][_eq]=true&fields=id,intelisis_movs,date_created,session_id,invoice_folio&limit=-1&sort=-date_created`;

            const response = await directusApi('GET', url);

            let invoices_info = response.data.data;

            // Segunda consulta - AGREGAR LIMIT=-1 para traer TODOS los registros
            let dateInvoiceMap = {};
            if (invoices_info.length > 0) {
                const invoiceFolios = invoices_info
                    .map(s => s.invoice_folio)
                    .filter(f => f)
                    .join(',');

                if (invoiceFolios) {
                    // AGREGAR limit=-1 AQUÍ
                    const url2 = `items/pdv_xml?filter[order][_in]=${invoiceFolios}&fields=order,date_created&sort=date_created&limit=-1`;
                    const xmlResponse = await directusApi('GET', url2);

                    // Crear un mapa con la primera fecha (MIN) por cada order
                    xmlResponse.data.data.forEach(xml => {
                        if (!dateInvoiceMap[xml.order]) {
                            dateInvoiceMap[xml.order] = xml.date_created;
                        }
                    });
                }
            }

            let invoice_count = 0;

            for (let i = 0; i < invoices_info.length; i++) {
                const intelisis_mov = invoices_info[i];

                const fechaVenta = moment(intelisis_mov.date_created)
                    .subtract(6, "hours")
                    .format("YYYY-MM-DDTHH:mm:ss");

                // Obtener la fecha de facturación del mapa SIN restar 6 horas
                const fechaFacturacion = intelisis_mov.invoice_folio && dateInvoiceMap[intelisis_mov.invoice_folio]
                    ? moment.utc(dateInvoiceMap[intelisis_mov.invoice_folio]).format("YYYY-MM-DDTHH:mm:ss")
                    : "Sin fecha de factura";

                const noVenta = intelisis_mov.id;
                const noSesion = intelisis_mov.session_id;

                const nuevosCampos: Record<string, any> = {};
                const movimientos = Array.isArray(intelisis_mov.intelisis_movs)
                    ? intelisis_mov.intelisis_movs
                    : [];

                let facturaPDVs = movimientos.filter(m => m.mov === "Factura Elect PDV");
                let facturaPDV = "No se encuentra movimiento de Intelisis";
                let facturaPDVDuplicada = null;

                for (let movs of movimientos) {
                    nuevosCampos[movs.mov] = movs.movid;

                    if (movs.mov === "Factura Elect PDV") {
                        if (movs.movid) {
                            facturaPDV = movs.movid;
                        }
                    }
                }

                if (
                    facturaPDVs.length > 1 &&
                    facturaPDVs.some(m => m.movid === null) &&
                    facturaPDVs.some(m => m.movid !== null)
                ) {
                    facturaPDVDuplicada = "Existe factura duplicada con movid null";
                }

                invoices_info[i] = {
                    "No. Venta": noVenta,
                    "No. Sesion": noSesion,
                    "Fecha de venta": fechaVenta,
                    "Fecha de facturación": fechaFacturacion,
                    ...nuevosCampos,
                    "Factura Elect PDV": facturaPDV,
                    ...(facturaPDVDuplicada ? { "Factura Elect PDV (Duplicada)": facturaPDVDuplicada } : {})
                };
            }

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(invoices_info);
            XLSX.utils.book_append_sheet(workbook, worksheet, "Ventas_facturadas");
            XLSX.writeFile(workbook, "Reporte_ventas_facturadas.xlsx");

        } catch (error) {
            console.log(error);
        }
    },

    async getMonthlySales({ _, commit }: any, data: any) {
        commit('monthlySummaryLoading', true);
        console.log('getting monthly sales report', data);
        try {
            const response = await directusApi(
                'POST',
                'custom/products/monthlySales',
                { date: data.date }
            );
            // console.log({ response });
            let monthly_sales = response.data.data;
            for (let i = 0; i < monthly_sales.length; i++) {
                const sales = monthly_sales[i];
                const fechaVenta = moment(sales.date_created)
                    .subtract(6, "hours")
                    .format("YYYY-MM-DDTHH:mm:ss");

                // Construir el objeto final
                monthly_sales[i] = {
                    "No. Venta": sales.id,
                    "No. Sesión": sales.session_id,
                    "Fecha de venta": fechaVenta,
                    "Total": sales.total,
                    "Estatus": sales.is_active ? 'Finalizada' : 'Cancelada'
                };
            }
            // console.log(monthly_sales);

            // Crear un libro de trabajo
            const workbook = XLSX.utils.book_new();

            // Convertir JSON a hoja de cálculo
            const worksheet = XLSX.utils.json_to_sheet(monthly_sales);

            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Ventas_facturadas");

            // Generar y descargar el archivo
            XLSX.writeFile(workbook, `Reporte_ventas_${data.date}.xlsx`);
            commit('monthlySummaryLoading', false);
        } catch (error) {
            commit('monthlySummaryLoading', false);
        }
    },
    async getMonthlyBox({ _, commit }: any, data: any) {
        commit('monthlySummaryLoading', true);
        console.log('getting monthly box cut report', data);
        try {
            const response = await directusApi(
                'POST',
                'custom/products/monthlyBox',
                { date: data.date }
            );
            // console.log({ response });
            let monthly_box = response.data.data;
            for (let i = 0; i < monthly_box.length; i++) {
                const box = monthly_box[i];
                const fechaCorteApertura = moment(box.date_open)
                    .subtract(6, "hours")
                    .format("YYYY-MM-DDTHH:mm:ss");
                const fechaCorteCierre = moment(box.date_close)
                    .subtract(6, "hours")
                    .format("YYYY-MM-DDTHH:mm:ss");

                // Construir el objeto final
                monthly_box[i] = {
                    "Sesión": box.id,
                    "Cajero": box.first_name,
                    "Fecha de apertura de corte": fechaCorteApertura,
                    "Fecha de cierre de corte": fechaCorteCierre == 'Fecha invalida' ? 'No cerrado' : fechaCorteCierre,
                    "Monto efectivo": box.amount_cash,
                    "Monto tarjeta de débito": box.amount_card_debit,
                    "Monto tarjeta de crédito": box.amount_card_credit,
                };
            }
            // console.log(monthly_sales);

            // Crear un libro de trabajo
            const workbook = XLSX.utils.book_new();

            // Convertir JSON a hoja de cálculo
            const worksheet = XLSX.utils.json_to_sheet(monthly_box);

            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Cortes finalizados");

            // Generar y descargar el archivo
            XLSX.writeFile(workbook, `Reporte_cortes_${data.date}.xlsx`);
            commit('monthlySummaryLoading', false);
        } catch (error) {
            commit('monthlySummaryLoading', false);
        }
    },
    async getSessionSales({ commit }: any, payload: { id: number }) {
        try {
            console.log('Get session sales');
            console.log('Session no.', payload.id);

            const response = await directusApi(
                'GET',
                `items/sales_pdv_v1?filter[session_id][_eq]=${payload.id}&fields=id,date_created,session_id,total,is_active,payment_way&limit=-1&sort=-date_created`
            );
            let session_sales = response.data.data;
            for (let i = 0; i < session_sales.length; i++) {
                const sales = session_sales[i];
                const fechaVenta = moment(sales.date_created)
                    .subtract(6, "hours")
                    .format("YYYY-MM-DDTHH:mm:ss");
                let payment_way = '';
                if (sales.payment_way == '28') {
                    payment_way = `${sales.payment_way} - T. Débito`;
                } else if (sales.payment_way == '04') {
                    payment_way = `${sales.payment_way} - T. Crédito`;
                } else if (sales.payment_way == '01') {
                    payment_way = `${sales.payment_way} - Efectivo`;
                }

                // Construir el objeto final
                session_sales[i] = {
                    "No. Venta": sales.id,
                    "No. Sesión": sales.session_id,
                    "Fecha de venta": fechaVenta,
                    "Total": sales.total,
                    "Estatus": sales.is_active ? 'Finalizada' : 'Cancelada',
                    "Forma de pago": payment_way
                };
            }

            // Crear un libro de trabajo
            const workbook = XLSX.utils.book_new();

            // Convertir JSON a hoja de cálculo
            const worksheet = XLSX.utils.json_to_sheet(session_sales);

            // Agregar la hoja al libro
            XLSX.utils.book_append_sheet(workbook, worksheet, "Ventas_facturadas");

            // Generar y descargar el archivo
            XLSX.writeFile(workbook, `Reporte_ventas_${payload.id}.xlsx`);

        } catch (error) {
            console.log(error);

        }
    },

    async updateSaleCancelActivate({ commit }: any, payload: { id: number; is_active: boolean }) {
        try {
            // 1. Actualizar venta principal
            console.log(payload.id);
            console.log(payload.is_active);


            const ventaResponse = await directusApi('PATCH', `items/sales_pdv_v1/${payload.id}`, {
                is_active: payload.is_active,
            });

            console.log('Venta y detalles actualizados');
            return ventaResponse.data.data;
        } catch (error) {
            console.error('Error al actualizar venta y detalles:', error);
            throw error;
        }
    },

    async getProductByIdSale({ _, commit, state }: any, payload: ISalesPdv) {
        return await directusApi('GET', `custom/products/details_pdv/${payload.id}`)
    },

    async insertCancelDescription({ _, commit }: any, payload: any) {
        try {
            console.log(payload.data.cancel_detail);
            console.log(payload.data.id);


            const reason_to_cancel = await directusApi('PATCH', `items/sales_pdv_v1/${payload.data.id}`, {
                cancel_detail: payload.data.cancel_detail
            }).then(async res => {
                // const intelisis_update = await directusApi('POST', `custom/legacy-intelisis/pdv/cancelDetail`, {
                //     cancel_detail: payload.data.cancel_detail
                // });
                // console.log({ intelisis_update });

                payload.vm.$bvToast.toast(`Detalle de cancelación guardado venta ${payload.data.id}`, {
                    title: 'Éxito',
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    solid: true,
                });
                // return res;
            })
        } catch (error) {
            payload.vm.$bvToast.toast('No se ha registrado el detalle de cancelacion de la venta', {
                title: `Detalle de cancelación`,
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                noAutoHide: true
            });
        }
    },

    async getLastSale({ _, commit, state }: any, payload: any) {
        const { session, vm } = payload
        const { data } = await directusApi('GET', `items/sales_pdv_v1?sort=-id&filter[user_id][_eq]=${session}&meta=total_count&meta=filter_count&limit=1`)
        const sale_id = data.data[0] ? data.data[0].id : null

        if (!sale_id) {
            vm.$bvToast.toast(`No se encontraron registros para esta sesión`, {
                title: `Sin resultados`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            return
        }

        const response = await directusApi('GET', `custom/products/details_pdv/${sale_id}`)
        return response.data.data
    },

    async getLastBoxCut({ _, commit, state }: any, session: string) {
        const { data } = await directusApi('GET', `items/sessions_pdv_v1?limit=1&page=1&sort=-date_close&meta=total_count&meta=filter_count&filter[date_close][_nnull]=true&filter[user_id][_eq]=${session}`)
        return data.data[0]
    },

    async checkSaleCancel({ _, commit, state }: any, payload: any) {
        const { sale, vm } = payload;
        // console.log('fecha de venta: ', sale.date_created);
        const fechaOriginal = new Date(sale.date_created);
        fechaOriginal.setHours(fechaOriginal.getHours() - 6);

        if (isToday(fechaOriginal)) {
            // const { data } = await directusApi('POST', `custom/legacy-intelisis/checkInvoice/validate`, { reference: `PDV-${sale.id} S-${sale.session_id}` });
            // if (!data.data.mov) {
            //     return true;
            // } else {
            //     vm.$bvToast.toast(`La venta ya tiene asociada una factura`, {
            //         title: `No es posible cancelar la venta`,
            //         variant: 'danger',
            //         toaster: 'b-toaster-top-center',
            //         autoHideDelay: 5000,
            //     });
            //     return false;
            // }
            return true;
        } else {
            vm.$bvToast.toast(`No puedes cancelar ventas de días anteriores`, {
                title: `No es posible cancelar la venta`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            return false;
        }
    },

    async RefreshMovIntelisis({ _, commit, state }: any, payload: any) {
        const { sale, session_id, vm } = payload;
        let data;
        try {
            data = await directusApi('GET', `custom/legacy-intelisis/intelisisMovsInfo/PDV-${sale} S-${session_id}`);
            vm.$bvToast.toast(`Información de movimientos actualizada`, {
                title: `Actualización`,
                variant: 'success',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 3000,
            })
        } catch (error) {
            vm.$bvToast.toast(`Error al actualizar el movimiento de intelisis`, {
                title: `Error de actualización`,
                variant: 'danger',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
        finally {
            return data.data.data.movements
        }
    },
    async PatchMovIntelisis({ _, commit, state }: any, sale_info: any) {
        const { sale_id, intelisis_movs, vm } = sale_info;
        await directusApi('PATCH', `items/sales_pdv_v1/${sale_id}`, { intelisis_movs: intelisis_movs })
            .then(res => {
                console.log("Datos actualizados");
            })
            .catch(err => {
                console.log("Error al insertar en la base de datos", err);
            });
    },
    async getIntelisisInfo({ _, commit, state }: any, sale_id: any) {
        return directusApi('GET', `items/sales_pdv_v1/${sale_id.id}?fields=intelisis_movs`)
            .then(res => {
                return res.data.data  // ✅ Se retorna correctamente
            })
            .catch(err => {
                console.log("Error al obtener datos", err)
            })
    }
};

// Exportar el módulo completo
export default {
    namespaced: true,
    state,
    mutations,
    // getters,
    actions,
};